import { makeActionCreator } from '../../../../utilities'
import { QaAddendumConstants } from './qaAddendum.constants'

export const setFlagDetail = makeActionCreator(QaAddendumConstants.SET_FLAG_DETAIL, 'selectedFlagDetail')
export const setAddendumText = makeActionCreator(QaAddendumConstants.SET_ADDENDUM_TEXT, 'addendumText')
export const setSelectedFlagId = makeActionCreator(QaAddendumConstants.SET_SELECTED_FLAG_ID, 'selectedFlagId')
export const fetchQaFlagDetail = makeActionCreator(QaAddendumConstants.FETCH_QA_FLAG_DETAIL, 'flagId')
export const fetchChartSummary = makeActionCreator(QaAddendumConstants.FETCH_CHART_SUMMARY, 'flagId')
export const setChartSummary = makeActionCreator(
  QaAddendumConstants.SET_CHART_SUMMARY,
  'chartSummary',
  'chartSummaryFlagId'
)
export const submitQaFlagAddendum = makeActionCreator(QaAddendumConstants.SUBMIT_QA_FLAG_ADDENDUM)
export const setQaAddendumSubmitting = makeActionCreator(QaAddendumConstants.SET_SUBMITTING, 'isSubmitting')
export const setReassignAssignee = makeActionCreator(QaAddendumConstants.SET_REASSIGN_ASSIGNEE, 'reassignAssignee')
export const setReassignReason = makeActionCreator(QaAddendumConstants.SET_REASSIGN_REASON, 'reassignReason')
export const resetReassign = makeActionCreator(QaAddendumConstants.RESET_REASSIGN)
export const resetQaAddendumDraftInputs = makeActionCreator(QaAddendumConstants.RESET_DRAFT_INPUTS)
export const reassignQaFlag = makeActionCreator(QaAddendumConstants.REASSIGN_QA_FLAG)
export const resetQaAddendumState = makeActionCreator(QaAddendumConstants.RESET_STATE)
